import { Map } from "immutable";

import { ClassEnrichedWithUserInfo } from "@seneca/class-service-types";
import { SchoolEntityI } from "@seneca/schools-service-types";

import { queryClient } from "services";

import { schoolClassesKey, schoolsKey } from "../../../consts";

export const getSchoolClasses = (schoolId: string) => {
  return (
    queryClient.getQueryData<ClassEnrichedWithUserInfo[]>([
      schoolClassesKey,
      schoolId
    ]) || []
  );
};

export const getSchoolClassesAlphabeticallyByName = (schoolId: string) => {
  const schoolClasses = getSchoolClasses(schoolId);
  return schoolClasses.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
};

export const getAllSchoolClasses = () => {
  const schools = queryClient.getQueryData<SchoolEntityI[]>([schoolsKey]) || [];
  return schools.reduce<ClassEnrichedWithUserInfo[]>((classes, school) => {
    const schoolClasses = getSchoolClasses(school.schoolId);
    return [...classes, ...schoolClasses];
  }, []);
};

export const getAllSchoolClassesAlphabeticallyByName = () => {
  const schoolClasses = getAllSchoolClasses();
  return schoolClasses.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
};

export const getAllSchoolClassesIdNameMap = () => {
  const schoolClasses = getAllSchoolClasses();
  return schoolClasses.reduce((idNameMap: any, schoolClass: any) => {
    return idNameMap.set(schoolClass.classId, schoolClass.name);
  }, Map());
};
